import React, { useState } from 'react';
import { ModalBody, ModalFooter, H3, Text, ModalContent, ModalHeader, } from '@noom/wax-component-library';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '../../../../core/components/Button';
import { InterestSelect } from '../components/InterestSelect';
export function InterestSelectView({ isLoading, onSubmit, interests = [], }) {
    const [selected, setSelected] = useState([]);
    return (React.createElement(ModalContent, null,
        React.createElement(ModalHeader, null,
            React.createElement(H3, { mb: 2, fontWeight: "500" },
                React.createElement(FormattedMessage, { id: "onboarding.interests.title" })),
            React.createElement(Text, { size: "md", fontWeight: "normal" },
                React.createElement(FormattedMessage, { id: "onboarding.interests.subTitle", values: {
                        b: (text) => React.createElement("b", null, text),
                    } }))),
        React.createElement(ModalBody, { display: "flex", flexDir: "column" },
            React.createElement(InterestSelect, { interests: interests, isDisabled: isLoading, onChange: setSelected })),
        React.createElement(ModalFooter, null,
            React.createElement(PrimaryButton, { isFullWidth: true, isLoading: isLoading, onClick: () => onSubmit(selected) },
                React.createElement(FormattedMessage, { id: "onboarding.interests.button" })))));
}
//# sourceMappingURL=InterestSelectView.js.map